// CodeReviewDanyDone: Change to ts
import {createAsyncThunk} from '@reduxjs/toolkit';

export const getPMWLangsVersion = createAsyncThunk('getPMWLangsVersion', async () => {
  return window.PMW.readLocal('lang/getPMWLangsVersion');
});
export const getSupportedLanguages = createAsyncThunk('getSupportedLanguages', async () => {
  return window.PMW.readLocal('lang/getSupportedLanguages');
});
